import { useEffect } from "react"
import { useLocation } from "react-router-dom"
import type { PostHog } from "posthog-js"
import { syncPostHogAppCapture } from "@/lib/posthog/appCapture"
import { getPostHogPageviewProperties, getPostHogRouteClientId, syncPostHogRouteContext } from "@/lib/posthog/route"

type PostHogRouteTrackerProps = {
  client: PostHog
}

let lastPageviewSignature = ""

export function PostHogRouteTracker({ client }: PostHogRouteTrackerProps) {
  const { pathname, search } = useLocation()

  useEffect(() => {
    const route = `${pathname}${search}`
    const clientId = getPostHogRouteClientId(pathname)
    const pageviewSignature = `${window.location.href}:${clientId ?? ""}`

    syncPostHogAppCapture(client, pathname)
    syncPostHogRouteContext({ clientId, route })
    if (lastPageviewSignature !== pageviewSignature) {
      client.capture("$pageview", getPostHogPageviewProperties({ clientId, route }))
      lastPageviewSignature = pageviewSignature
    }
  }, [client, pathname, search])

  return null
}
